import { type PreviewConfig } from '../types.js';

export const previewConfig: PreviewConfig = {
  images: {
    set: {
      dawn: 'set_02',
      dusk: 'set_03',
      midday: 'set_02',
      midnight: 'set_01',
      morning: 'set_02',
    },
    useHighRes: true,
  },
  projects: {
    quantity: 4,
  },
  services: {
    quantity: 2,
  },
};
